import React, { useEffect, useState, useContext } from "react";
import GetBaseUrl from "../functions/SetBaseUrl";
import GraphQuery from "./AUD_DashboardElements_New/Graphs/GraphQuery";
import DashboardHeader from "./AUD_DashboardElements_New/DashboardHeader";
import DashboardStatics from "./AUD_DashboardElements_New/DashboardStatics";
import "./AUD_DashboardElements_New/Dashboard.css";
import { Scholarship } from "./AUD_DashboardElements_New/Charts/Scholarship";
import { Programs } from "./AUD_DashboardElements_New/Charts/Programs";
import { IndexContext } from "../components/layout/Layout";
import axios from "axios";

const BaseUrl = GetBaseUrl()[0];
var token = localStorage.getItem(GetBaseUrl()[1] + "_Edu_AuthToken");

const Dashboard = () => {
  const [editMode, setEditMode] = useState(false);
  const [filter1Name, setFilter1Name] = useState("");
  const [filter2Name, setFilter2Name] = useState("");
  const [comparisonMode, setComparisonMode] = useState(false);
  const [graphs, setGraphs] = useState([]);
  const [multiGraphs, setMultiGraphs] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [selectedComparisonFilters, setSelectedComparisonFilters] = useState(
    []
  );
  const [selectedOptionalFilterData, setSelectedOptionalFilterData] = useState(
    []
  );
  const [reloadDashboard, setReloadDashboard] = useState(0);
  //-------------------------------------------------------
  let queryStructures2_1 = `Select
  Count - Distinct(User_name)
  Group By - Grade_level`;

  let queryStructures2_2 = `Select
  Count - Distinct(User_name)
  Group By - Grade_level`;

  let queryStructures2_3 = `Select
  Count - Distinct(User_name)
  Group By - Grade_level`;

  let queryStructures3_1 = `Select
  Count
  Group By - visitdate`;

  let queryStructures3_2 = `Select
  Count
  Group By - Created_at`;

  let queryStructures3_3 = `Select
  Count
  Group By - Created_at`;

  let queryStructures3_4 = `Select
  Count
  Group By - Created_at`;
  //-------------------------------------------------------
  const [queryStructures, setQueryStructures] = useState([
    {
      index: [21, 22, 23, 24],
      titles: ["Nationality"],
      widgetType: ["LineGraph"],
      graphType: ["flag"],
      HeaderFilter: [[], [], [], []],
      seriesTitles: ["Active"],
      max: 10,
      height: 400,
      title: "",
      stacked: false,
      pre: "",
      options: [queryStructures3_4],
    },
  ]);

  //---------------------
  useEffect(() => {
    selectedOptionalFilterData &&
      selectedOptionalFilterData.length &&
      viewQueryResult(
        [selectedOptionalFilterData[0] && selectedOptionalFilterData[0].graph],
        selectedFilters
      );
  }, [selectedOptionalFilterData]);
  //---------------------------------------------------
  const viewQueryResult = (charts = [], Filters = []) => {
    if (charts.length) {
      getGraphResult(charts, Filters);
    } else {
      setGraphs([]);
      getGraphResult([21, 22, 23, 24], Filters);
      getGraphResult([41, 42, 43], Filters);
    }
  };
  //---------------------------------------------------getGraphResult
  const getGraphResult = async (graphIndex, Filters = [], multi = false) => {
    let fullArray = [];
    for (let i = 0; i < graphIndex.length; i++) {
      const element = graphIndex[i];
      let obj = {
        queryId: element,
        filterData: Filters,
        comparisonFilterData: selectedComparisonFilters,
        optionalFilterData: selectedOptionalFilterData,
      };

      obj.optionalFilterData &&
        !obj.optionalFilterData.length &&
        delete obj.optionalFilterData;

      [21, 23, 24, 25, 41, 42, 43].indexOf(element) > -1 &&
        delete obj.optionalFilterData;

      //------------------Default School type for school graph only
      [22].indexOf(element) > -1 &&
        !obj.optionalFilterData &&
        (obj.optionalFilterData = [
          {
            columnName: "school_partner",
            filterValue: "FALSE",
            graph: 22,
          },
        ]);
      //------------------Default School type for school graph only

      obj.comparisonFilterData &&
        !obj.comparisonFilterData.length &&
        delete obj.comparisonFilterData;

      if (Filters.length) {
        try {
          const response = await axios.post(
            BaseUrl + "/Report/GetDashboardReportQueryData",
            obj,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "content-type": "application/json",
              },
            }
          );

          fullArray.push({ queryId: element, content: response.data });
        } catch (error) {
          fullArray.push({
            queryId: element,
            content: [],
          });
        }
      }
    }
    if (multi) {
      setMultiGraphs(fullArray);
    } else {
      setGraphs(fullArray);
    }
  };

  //---------------------
  useEffect(() => {
    !comparisonMode && setSelectedComparisonFilters([]);
  }, [comparisonMode]);

  //----------------------------------------------getGraphResult
  return (
    <div className="rounded-0 Dashboard-container min-vh-85">
      <DashboardHeader
        setEditMode={setEditMode}
        editMode={editMode}
        setComparisonMode={setComparisonMode}
        comparisonMode={comparisonMode}
        withQuery={editMode}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        viewQueryResult={viewQueryResult}
        setReloadDashboard={setReloadDashboard}
        setSelectedComparisonFilters={setSelectedComparisonFilters}
        selectedComparisonFilters={selectedComparisonFilters}
        setFilter1Name={setFilter1Name}
        setFilter2Name={setFilter2Name}
      />
      <DashboardStatics
        setEditMode={setEditMode}
        editMode={editMode}
        comparisonMode={comparisonMode}
        withQuery={editMode}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        reloadDashboard={reloadDashboard}
        setReloadDashboard={setReloadDashboard}
        viewQueryResult={viewQueryResult}
        selectedComparisonFilters={selectedComparisonFilters}
        filter1Name={filter1Name}
        filter2Name={filter2Name}
        setFilter1Name={setFilter1Name}
        setFilter2Name={setFilter2Name}
      />

      <div className="charts-container row ">
        <GraphQuery
          withTabs
          selectedFilters={selectedFilters}
          key={queryStructures[0].index}
          height={queryStructures[0].height}
          title={queryStructures[0].title}
          widgetType={queryStructures[0].widgetType}
          data={graphs}
          setEditMode={setEditMode}
          editMode={editMode}
          viewQueryResult={viewQueryResult}
          // SelectTopBtn={SelectTopBtn}
          setSelectedOptionalFilterData={setSelectedOptionalFilterData}
          index={queryStructures[0].index}
          titles={queryStructures[0].titles}
          reloadDashboard={reloadDashboard}
          graphType={queryStructures[0].graphType}
          HeaderFilter={queryStructures[0].HeaderFilter}
          queryStructures={queryStructures[0].options}
          seriesTitles={
            comparisonMode
              ? [
                  filter1Name && filter1Name.value,
                  filter2Name && filter2Name.value,
                ]
              : queryStructures[0].seriesTitles
          }
          max={queryStructures[0].max}
          stacked={queryStructures[0].stacked}
          pre={queryStructures[0].pre}
          maxCategoryLength={10}
          scroll
          selectedComparisonFilters={selectedComparisonFilters}
          filter1Name={filter1Name}
          filter2Name={filter2Name}
          setFilter1Name={setFilter1Name}
          setFilter2Name={setFilter2Name}
          comparisonMode={comparisonMode}
        />
        <Scholarship
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          tableTitle={""}
          widgetType=""
          queryStructures={[]}
          withQuery={editMode}
          filter1Name={filter1Name}
          filter2Name={filter2Name}
          setFilter1Name={setFilter1Name}
          setFilter2Name={setFilter2Name}
          comparisonMode={comparisonMode}
        />

        {/* <Programs
          selectedFilters={selectedFilters}
          viewQueryResult={viewQueryResult}
          queryResult={graphs}
          setEditMode={setEditMode}
          editMode={editMode}
          reloadDashboard={reloadDashboard}
          QS={queryStructures[1]}
          filter1Name={filter1Name}
          filter2Name={filter2Name}
          setFilter1Name={setFilter1Name}
          setFilter2Name={setFilter2Name}
          setSelectedFilters={setSelectedFilters}
          comparisonMode={comparisonMode}
          setSelectedOptionalFilterData={setSelectedOptionalFilterData}
        /> */}
      </div>
    </div>
  );
};

export default Dashboard;
